export enum ArmorType {
    Cloak = 0,
    Cloth = 1,
    Leather = 2,
    Mail = 3,
    Plate = 4,
    Tabard = 21,
    None = 1000,
}
